import React, { useMemo, useState } from 'react';
import { KeyRound, Sparkles } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../utils/api';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();

    if (!token) {
      setError('Brakuje tokenu resetu hasła. Otwórz link jeszcze raz z maila.');
      return;
    }

    if (password.length < 6) {
      setError('Hasło powinno mieć co najmniej 6 znaków.');
      return;
    }

    if (password !== passwordConfirm) {
      setError('Hasła muszą być identyczne.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await api.post('/auth/reset-password', { token, password });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Nie udało się ustawić nowego hasła.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card auth-card--wide auth-card--compact">
        <div className="login-logo">
          <Sparkles size={22} strokeWidth={1.8} />
        </div>
        <p className="login-kicker">Nowe hasło</p>
        <h1 className="login-title auth-title-small">Ustaw nowe hasło</h1>
        <p className="login-subtitle">Po zapisaniu nowego hasła możesz od razu wrócić do panelu.</p>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">Hasło zostało zmienione. Możesz się zalogować.</div>}

        {!success && (
          <form onSubmit={handleSubmit} className="login-form auth-form-grid">
            <div className="form-group auth-form-full">
              <label htmlFor="password">Nowe hasło</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                  setError('');
                }}
                autoComplete="new-password"
                required
              />
            </div>
            <div className="form-group auth-form-full">
              <label htmlFor="passwordConfirm">Powtórz hasło</label>
              <input
                id="passwordConfirm"
                type="password"
                value={passwordConfirm}
                onChange={(event) => {
                  setPasswordConfirm(event.target.value);
                  setError('');
                }}
                autoComplete="new-password"
                required
              />
            </div>
            <button type="submit" className="btn-primary auth-form-full" disabled={loading}>
              <KeyRound size={16} strokeWidth={1.9} />
              {loading ? 'Zapisywanie...' : 'Zapisz nowe hasło'}
            </button>
          </form>
        )}

        <p className="auth-switch-copy">
          <Link to="/login" className="auth-switch-link">Przejdź do logowania</Link>
        </p>
      </div>
    </div>
  );
}